





































import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import { Controlador as Model, ControladorDeCurso } from '../curso-controlador';
import { Recurso } from '@/__env/lib/Cursos/Recursos';
import { Wait } from '@/__env/ext';
import { Pregunta } from '@/__env/lib/Cursos/Preguntas';
import { Curso } from '@/__env/lib/Cursos';
import { isNumber, isArray } from 'util';
@Component( {
    name: "Componente",
    props: {},
    components: {
    }
} )
export default class Componente extends Vue
{
    public get Controlador(): ControladorDeCurso { return Model; }
    public get Curso(): Curso { return Model.Curso; }

    @Prop()
    public Pregunta: Pregunta;

    public Opciones: number | number[] = [];
    public get Valido(): boolean
    {
        return ( isNumber( this.Opciones ) && this.Opciones >= 0 ) || ( isArray( this.Opciones ) && this.Opciones.hasRows() );

    }

    public get Centrado(): boolean
    {
        return this.Pregunta.Opciones.filter( x => x.Opcion.length > 30 ).hasRows();

    }

    Contestando: boolean = false;
    async Siguiente()
    {
        this.Contestando = true;

        let e = await this.Pregunta.Contestar( this.Opciones );
        await Wait( 1200 );
        if ( e )
        {
            this.Contestando = false;
            this.$emit( 'siguiente' );
        } else
        {
            this.Contestando = false;
            this.$EventBus.Notificaciones.Error( 'Ocurrió un error' );
        }



    }
}
